import { LeaderboardV2TabOption } from '@/types/homepage.types';

export const LEADERBOARD_V2_TAB_OPTIONS: LeaderboardV2TabOption[] = [
  { value: 'F', label: "WOMEN'S" },
  { value: 'M', label: "MEN'S" },
];

export const LEADERBOARD_V2_DEFAULT_TAB_VALUE: LeaderboardV2TabOption = {
  value: 'F',
  label: "WOMEN'S",
};

export const COLUMN_HEADERS = [
  { label: 'Rank', className: 'w-11 shrink-0' },
  { label: 'Player', className: 'flex-1 pl-5 pr-7' },
  { label: 'Country', className: 'flex-1 pl-9' },
  { label: 'Points', className: 'w-10 shrink-0 text-right' },
];
